import { FileCheck2, ArrowUpRight } from "lucide-react";

// COA badge shown only on retatrutide products (never bacteriostatic water).
// Name-based so dynamically added catalog products get it automatically.
export const isRetatrutideProduct = (p) => /retatrutide/i.test(p?.name || "");

// Plain <a> (not router Link) so the COA opens in a new tab and the
// shopper never loses their place in the shop.
export const CoaBadge = ({ product, className = "" }) => {
  if (!isRetatrutideProduct(product)) return null;
  return (
    <a
      href="/lab-results/retatrutide"
      target="_blank"
      rel="noopener noreferrer"
      data-testid={`coa-badge-${product.id}`}
      aria-label={`View third-party testing (COA) for ${product.name} (opens in a new tab)`}
      onClick={(e) => e.stopPropagation()}
      className={`absolute top-2 right-2 z-10 inline-flex items-center gap-1 rounded-sm border border-[#7CE3A6]/60 bg-black/70 px-2 py-1 text-[10px] font-bold uppercase tracking-[0.15em] text-[#7CE3A6] backdrop-blur hover:bg-[#7CE3A6] hover:text-black transition-colors ${className}`}
    >
      <FileCheck2 size={11} /> COA <ArrowUpRight size={11} />
    </a>
  );
};
